export const rgbColors = [
  "#4CA28E",
  "#FFD494",
  "#F59E0B",
  "#E4465F"
];